import {
    Box, Modal, ModalOverlay, ModalContent, ModalHeader, Text, ModalCloseButton, ModalBody, Flex, IconButton, ModalFooter, Tooltip,
    Button, Spinner, useToast, FormControl, FormLabel, HStack, Badge, Input, Grid, GridItem, Divider, VStack
} from '@chakra-ui/react';
import { FaTrash, FaInfoCircle, FaEdit, FaFilePdf } from 'react-icons/fa';
import React, { useEffect, useState } from 'react';
import { emitirNfML, downloadNfeArquivo } from "../../services/api";
import { mensagemDeErro } from "../../utils/erroApi";
import ProdutoImagem from "../ProdutoImagem";
import {
    SeletorEmissorNfe, BadgeEmissor, useConfigEmissorNfeMl, emissorDaVenda,
    EMISSOR_PADRAO, EMISSOR_INTERNO, EMISSOR_ML
} from "../EmissorNfeMl";

// Vendas do mesmo pacote (carrinho) saem numa nota so: vao juntas na mesma chamada.
const chaveDoPacote = (venda) => `${venda.conta || 0}-${venda.pack_id || venda.id_taga || venda.id}`;

const porId = (lista) => {
    const mapa = {};
    (Array.isArray(lista) ? lista : []).forEach((item) => {
        if (item && item.id !== undefined && item.id !== null) mapa[String(item.id)] = item;
    });
    return mapa;
};

const ModalNfeVendas = ({ handleCheckboxChange, setCheckboxesState, limitarCaracteres,
    isModalOpenEmitirNfesMassaML, setIsModalOpenEmitirNfesMassaML, vendasSelecionadasEmitirNfeMassa,
    setVendasSelecionadasEmitirNfeMassa, pedidos, setPedidos }) => {

    const [isModalOpenConfirmNFMassa, setIsModalOpenConfirmNFMassa] = useState(false);

    const [isModalEditPayloadOpen, setIsModalEditPayloadOpen] = useState(false);
    const [editingVenda, setEditingVenda] = useState(null);
    const [editingPayload, setEditingPayload] = useState(null);
    const [customPayloads, setCustomPayloads] = useState({});
    const [serverPayloads, setServerPayloads] = useState({});


    const closeModalConfirmNFMassa = () => setIsModalOpenConfirmNFMassa(false);
    const openModalConfirmNFMassa = () => {
        setIsModalOpenConfirmNFMassa(true);
    };

    // Emissor das vendas do ML neste lote (padrao de cada conta, interno ou faturador do ML)
    // e ensaio em homologacao (so no interno: sem valor fiscal, nada vai ao ML).
    const [emissorNfe, setEmissorNfe] = useState(EMISSOR_PADRAO);
    const [ensaio, setEnsaio] = useState(false);
    const [resultadosEnsaio, setResultadosEnsaio] = useState({});
    const [baixandoDanfe, setBaixandoDanfe] = useState(null);
    const configEmissor = useConfigEmissorNfeMl(isModalOpenEmitirNfesMassaML);
    const ensaioAtivo = ensaio && emissorNfe !== EMISSOR_ML;
    const escolhaEfetiva = ensaioAtivo ? EMISSOR_INTERNO : emissorNfe;

    useEffect(() => {
        if (emissorNfe === EMISSOR_ML && ensaio) setEnsaio(false);
    }, [emissorNfe, ensaio]);


    const toast = useToast()
    const [mensagensErroNfeMassa, setMensagensErroNfeMassa] = useState({});
    const [statusVendasNfeMassa, setStatusVendasNfeMassa] = useState({});
    const [isLoadingNfeMassa, setIsLoadingNfeMassa] = useState(false);
    const closeModalEmitirNfesMassaML = () => setIsModalOpenEmitirNfesMassaML(false);
    const removerVendaEmitirNfeMasas = (id) => {
        setVendasSelecionadasEmitirNfeMassa((prevVendas) => {
            const novasVendas = prevVendas.filter(venda => venda.id !== id);
            if (novasVendas.length === 0) {
                handleCancelEmitirNfesMassaML();
            }
            return novasVendas;
        });

        const newPayloads = { ...customPayloads };
        delete newPayloads[id];
        setCustomPayloads(newPayloads);

        handleCheckboxChange(id);
    };
    const handleCancelEmitirNfesMassaML = () => {
        closeModalEmitirNfesMassaML();
        setVendasSelecionadasEmitirNfeMassa([]);
        // setCheckboxesState([]);
        setStatusVendasNfeMassa({});
        setIsLoadingNfeMassa(false);
        setMensagensErroNfeMassa({});
        setEmissorNfe(EMISSOR_PADRAO);
        setEnsaio(false);
        setResultadosEnsaio({});
        setCustomPayloads({});
        setServerPayloads({});
    };

    const handleClickEmitirNfesMassaML = () => {
        closeModalConfirmNFMassa();
        processarLote();
    };

    const atualizarStatus = (vendas, status) => {
        setStatusVendasNfeMassa((anterior) => {
            const novo = { ...anterior };
            vendas.forEach((v) => { novo[v.id] = status; });
            return novo;
        });
    };

    // Um pacote por vez (cada chamada emite uma nota): progresso por linha e sem
    // requisicao longa demais para o lote inteiro.
    const processarLote = async () => {
        setIsLoadingNfeMassa(true);

        const pendentes = vendasSelecionadasEmitirNfeMassa.filter((v) => statusVendasNfeMassa[v.id] !== 'CONCLUÍDO');
        const grupos = [];
        const indice = {};
        pendentes.forEach((v) => {
            const chave = chaveDoPacote(v);
            if (!indice[chave]) {
                indice[chave] = [];
                grupos.push(indice[chave]);
            }
            indice[chave].push(v);
        });

        const contagem = { emitidas: 0, ensaios: 0, erros: 0 };
        const mensagens = {};
        const payloadsServidor = {};
        const ensaios = {};
        const concluidas = [];

        for (const grupo of grupos) {
            atualizarStatus(grupo, 'PROCESSANDO');

            let consulta = `id=${grupo.map((v) => v.id_taga).join(',')}`;
            if (escolhaEfetiva !== EMISSOR_PADRAO) consulta += `&emissor=${escolhaEfetiva}`;
            if (ensaioAtivo) consulta += '&ambiente=homologacao';

            const payloadsDoGrupo = {};
            grupo.forEach((v) => {
                if (!customPayloads[v.id]) return;
                try {
                    payloadsDoGrupo[v.id_taga] = JSON.parse(customPayloads[v.id]);
                } catch (e) {
                    console.error('Correção da nota com JSON inválido', e);
                }
            });

            const resposta = await emitirNfML(consulta, { custom_payloads: payloadsDoGrupo });
            const sucessos = porId(resposta?.sucessos);
            const testes = porId(resposta?.testes);
            const erros = porId(Array.isArray(resposta?.erros) ? resposta.erros : (Array.isArray(resposta?.error) ? resposta.error : []));
            const statusGrupo = {};

            grupo.forEach((v) => {
                const chave = String(v.id_taga);
                if (erros[chave]) {
                    statusGrupo[v.id] = 'ERRO';
                    mensagens[v.id] = mensagemDeErro(erros[chave], 'Erro ao emitir a NF-e (a API não retornou detalhe).');
                    if (erros[chave]?.retorno?.payload) payloadsServidor[v.id] = erros[chave].retorno.payload;
                    contagem.erros += 1;
                } else if (testes[chave]) {
                    statusGrupo[v.id] = 'ENSAIO';
                    ensaios[v.id] = { ...(testes[chave].nfe || {}), mensagem: testes[chave].mensagem, avisos: testes[chave].avisos || [] };
                    contagem.ensaios += 1;
                } else if (sucessos[chave] || (resposta && resposta.status === true && Object.keys(erros).length === 0)) {
                    statusGrupo[v.id] = 'CONCLUÍDO';
                    concluidas.push(v.id);
                    contagem.emitidas += 1;
                } else {
                    statusGrupo[v.id] = 'ERRO';
                    mensagens[v.id] = resposta === false
                        ? 'Falha de conexão com a API ao emitir a NF-e. Confira a venda antes de tentar de novo.'
                        : mensagemDeErro(resposta, 'A API não retornou resultado para esta venda.');
                    contagem.erros += 1;
                }
            });

            setStatusVendasNfeMassa((anterior) => ({ ...anterior, ...statusGrupo }));
            setMensagensErroNfeMassa((anterior) => ({ ...anterior, ...mensagens }));
            setServerPayloads((anterior) => ({ ...anterior, ...payloadsServidor }));
            setResultadosEnsaio((anterior) => ({ ...anterior, ...ensaios }));
        }

        if (concluidas.length > 0) {
            setCustomPayloads((anterior) => {
                const novo = { ...anterior };
                concluidas.forEach((id) => { delete novo[id]; });
                return novo;
            });
            pedidos.forEach((pedido) => {
                if (concluidas.includes(pedido.id)) pedido.notaEmitida = true;
            });
            setPedidos([...pedidos]);
        }

        setIsLoadingNfeMassa(false);

        const partes = [];
        if (contagem.emitidas) partes.push(`${contagem.emitidas} emitida(s)`);
        if (contagem.ensaios) partes.push(`${contagem.ensaios} ensaio(s) em homologação`);
        if (contagem.erros) partes.push(`${contagem.erros} com erro`);
        toast({
            title: contagem.erros ? 'Lote concluído com erros' : 'Lote concluído',
            description: partes.join(' · ') || 'Nada processado.',
            status: contagem.erros ? (contagem.emitidas || contagem.ensaios ? 'warning' : 'error') : 'success',
            duration: 6000,
            isClosable: true,
        });
    };

    const abrirDanfeEnsaio = async (vendaId) => {
        const nfe = resultadosEnsaio[vendaId];
        if (!nfe?.id) return;
        setBaixandoDanfe(vendaId);
        const resposta = await downloadNfeArquivo(`/nfe/danfe/${nfe.id}`);
        setBaixandoDanfe(null);
        if (!resposta?.data) {
            toast({ title: 'Não consegui baixar a DANFE do ensaio', status: 'error', duration: 4000 });
            return;
        }
        const url = window.URL.createObjectURL(new Blob([resposta.data], { type: 'application/pdf' }));
        window.open(url, '_blank');
        setTimeout(() => window.URL.revokeObjectURL(url), 60000);
    };

    const gerarPayloadInicial = (venda) => {
        const items = venda.produtos?.map(p => ({
            sku: p.id || '',
            name: p.nome || '',
            quantity: p.quantidade || 1,
            price: p.valor || 0,
            total: (p.quantidade || 1) * (p.valor || 0)
        })) || [];

        const payloadSchema = {
            customer: {
                name: venda.comprador?.nickname || '',
                email: 'email@exemplo.com',
                document: { type: 'CPF', number: '' },
                ie: ''
            },
            shippingAddress: {
                zipCode: '', street: '', number: '', complement: '', neighborhood: '', city: '', state: '', country: 'Brasil'
            },
            items: items,
            totals: { subtotal: 0, shippingCost: 0, discount: 0, total: 0 },
            payment: { method: 'CREDIT_CARD', installments: 1 },
            orderNumber: venda.id_origem || '',
            modalidadeFrete: '0'
        };
        return JSON.stringify(payloadSchema);
    };

    const handleOpenEditPayload = (venda) => {
        setEditingVenda(venda);
        let payloadStr = '';
        if (customPayloads[venda.id]) {
            payloadStr = customPayloads[venda.id];
        } else if (serverPayloads[venda.id]) {
            payloadStr = typeof serverPayloads[venda.id] === 'object'
                ? JSON.stringify(serverPayloads[venda.id])
                : serverPayloads[venda.id];
        } else {
            payloadStr = gerarPayloadInicial(venda);
        }

        try {
            const parsed = JSON.parse(payloadStr);
            setEditingPayload(parsed);
        } catch (e) {
            console.error("Erro ao parsear payload para edição", e);
            toast({ title: "Erro ao abrir edição", status: "error" });
        }

        setIsModalEditPayloadOpen(true);
    };

    const handleSavePayload = () => {
        const jsonString = JSON.stringify(editingPayload);

        setCustomPayloads(prev => ({
            ...prev,
            [editingVenda.id]: jsonString
        }));

        setIsModalEditPayloadOpen(false);
        setEditingVenda(null);
        toast({ title: "Correções salvas para reenvio", status: "success", duration: 2000 });
    };

    const handleDiscardPayload = (vendaId) => {
        const newPayloads = { ...customPayloads };
        delete newPayloads[vendaId];
        setCustomPayloads(newPayloads);
        toast({ title: "Edição descartada", status: "info", duration: 2000 });
    };

    const handleInputChange = (section, field, value, subSection = null) => {
        setEditingPayload(prev => {
            if (subSection) {
                return {
                    ...prev,
                    [section]: {
                        ...prev[section],
                        [subSection]: {
                            ...prev[section]?.[subSection],
                            [field]: value
                        }
                    }
                };
            } else {
                return {
                    ...prev,
                    [section]: {
                        ...prev[section],
                        [field]: value
                    }
                };
            }
        });
    };


    return (
        <div>
            <Modal isOpen={isModalOpenConfirmNFMassa} onClose={closeModalConfirmNFMassa}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Confirmação</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Text fontSize="16" mb={2}>
                            {ensaioAtivo
                                ? 'Emitir ENSAIO em homologação (sem valor fiscal) para as vendas selecionadas?'
                                : 'Tem certeza de que deseja emitir a nota fiscal das vendas selecionadas?'}
                        </Text>
                        <Text fontSize="sm" color="gray.600" mb={2}>
                            {escolhaEfetiva === EMISSOR_INTERNO && 'Emissor: interno (TAGA), com o CNPJ de cada conta.'}
                            {escolhaEfetiva === EMISSOR_ML && 'Emissor: faturador do Mercado Livre.'}
                            {escolhaEfetiva === EMISSOR_PADRAO && 'Emissor: o padrão de cada conta (veja a etiqueta em cada venda).'}
                        </Text>
                    </ModalBody>
                    <ModalFooter>
                        <Button colorScheme="green" mr={3} onClick={handleClickEmitirNfesMassaML}>
                            Confirmar
                        </Button>
                        <Button variant="ghost" onClick={closeModalConfirmNFMassa}>
                            Cancelar
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            <Modal isOpen={isModalEditPayloadOpen} onClose={() => setIsModalEditPayloadOpen(false)} size="xl" scrollBehavior="inside">
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Corrigir Dados da Nota Fiscal</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        {editingPayload && (
                            <VStack spacing={5} align="stretch">
                                {/* Seção Cliente */}
                                <Box>
                                    <Text fontWeight="bold" mb={2} color="blue.600">Dados do Cliente</Text>
                                    <Grid templateColumns="repeat(2, 1fr)" gap={3}>
                                        <GridItem colSpan={2}>
                                            <FormControl>
                                                <FormLabel fontSize="sm">Nome / Razão Social</FormLabel>
                                                <Input
                                                    size="sm"
                                                    value={editingPayload.customer?.name || ''}
                                                    onChange={(e) => handleInputChange('customer', 'name', e.target.value)}
                                                />
                                            </FormControl>
                                        </GridItem>
                                        <GridItem>
                                            <FormControl>
                                                <FormLabel fontSize="sm">CPF / CNPJ</FormLabel>
                                                <Input
                                                    size="sm"
                                                    value={editingPayload.customer?.document?.number || editingPayload.customer?.cpf || editingPayload.customer?.cnpj || ''}
                                                    onChange={(e) => {
                                                        // Tenta atualizar onde encontrar, preferência para document.number
                                                        if (editingPayload.customer?.document) {
                                                            handleInputChange('customer', 'number', e.target.value, 'document');
                                                            // Atualiza type automaticamente baseado no tamanho
                                                            const type = e.target.value.replace(/\D/g, '').length > 11 ? 'CNPJ' : 'CPF';
                                                            handleInputChange('customer', 'type', type, 'document');
                                                        } else {
                                                            // Fallback para campos antigos se existirem
                                                            handleInputChange('customer', 'cpf', e.target.value);
                                                        }
                                                    }}
                                                />
                                            </FormControl>
                                        </GridItem>
                                        <GridItem>
                                            <FormControl>
                                                <FormLabel fontSize="sm">Inscrição Estadual</FormLabel>
                                                <Input
                                                    size="sm"
                                                    value={editingPayload.customer?.ie || ''}
                                                    onChange={(e) => handleInputChange('customer', 'ie', e.target.value)}
                                                />
                                            </FormControl>
                                        </GridItem>
                                        <GridItem colSpan={2}>
                                            <FormControl>
                                                <FormLabel fontSize="sm">Email</FormLabel>
                                                <Input
                                                    size="sm"
                                                    value={editingPayload.customer?.email || ''}
                                                    onChange={(e) => handleInputChange('customer', 'email', e.target.value)}
                                                />
                                            </FormControl>
                                        </GridItem>
                                    </Grid>
                                </Box>

                                <Divider />

                                {/* Seção Endereço */}
                                <Box>
                                    <Text fontWeight="bold" mb={2} color="blue.600">Endereço de Entrega</Text>
                                    <Grid templateColumns="repeat(4, 1fr)" gap={3}>
                                        <GridItem colSpan={1}>
                                            <FormControl>
                                                <FormLabel fontSize="sm">CEP</FormLabel>
                                                <Input
                                                    size="sm"
                                                    value={editingPayload.shippingAddress?.zipCode || ''}
                                                    onChange={(e) => handleInputChange('shippingAddress', 'zipCode', e.target.value)}
                                                />
                                            </FormControl>
                                        </GridItem>
                                        <GridItem colSpan={3}>
                                            <FormControl>
                                                <FormLabel fontSize="sm">Rua</FormLabel>
                                                <Input
                                                    size="sm"
                                                    value={editingPayload.shippingAddress?.street || ''}
                                                    onChange={(e) => handleInputChange('shippingAddress', 'street', e.target.value)}
                                                />
                                            </FormControl>
                                        </GridItem>
                                        <GridItem colSpan={1}>
                                            <FormControl>
                                                <FormLabel fontSize="sm">Número</FormLabel>
                                                <Input
                                                    size="sm"
                                                    value={editingPayload.shippingAddress?.number || ''}
                                                    onChange={(e) => handleInputChange('shippingAddress', 'number', e.target.value)}
                                                />
                                            </FormControl>
                                        </GridItem>
                                        <GridItem colSpan={3}>
                                            <FormControl>
                                                <FormLabel fontSize="sm">Complemento</FormLabel>
                                                <Input
                                                    size="sm"
                                                    value={editingPayload.shippingAddress?.complement || ''}
                                                    onChange={(e) => handleInputChange('shippingAddress', 'complement', e.target.value)}
                                                />
                                            </FormControl>
                                        </GridItem>
                                        <GridItem colSpan={2}>
                                            <FormControl>
                                                <FormLabel fontSize="sm">Bairro</FormLabel>
                                                <Input
                                                    size="sm"
                                                    value={editingPayload.shippingAddress?.neighborhood || ''}
                                                    onChange={(e) => handleInputChange('shippingAddress', 'neighborhood', e.target.value)}
                                                />
                                            </FormControl>
                                        </GridItem>
                                        <GridItem colSpan={1}>
                                            <FormControl>
                                                <FormLabel fontSize="sm">Cidade</FormLabel>
                                                <Input
                                                    size="sm"
                                                    value={editingPayload.shippingAddress?.city || ''}
                                                    onChange={(e) => handleInputChange('shippingAddress', 'city', e.target.value)}
                                                />
                                            </FormControl>
                                        </GridItem>
                                        <GridItem colSpan={1}>
                                            <FormControl>
                                                <FormLabel fontSize="sm">UF</FormLabel>
                                                <Input
                                                    size="sm"
                                                    value={editingPayload.shippingAddress?.state || ''}
                                                    maxLength={2}
                                                    onChange={(e) => handleInputChange('shippingAddress', 'state', e.target.value.toUpperCase())}
                                                />
                                            </FormControl>
                                        </GridItem>
                                    </Grid>
                                </Box>
                            </VStack>
                        )}
                    </ModalBody>
                    <ModalFooter>
                        <Button colorScheme="blue" mr={3} onClick={handleSavePayload}>
                            Salvar Correção
                        </Button>
                        <Button variant="ghost" onClick={() => setIsModalEditPayloadOpen(false)}>
                            Cancelar
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            <Modal isOpen={isModalOpenEmitirNfesMassaML} onClose={handleCancelEmitirNfesMassaML} size={{ base: "full", md: "2xl", lg: "4xl" }} scrollBehavior="inside">
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader pr={12}><Text fontSize={{ base: "16px", md: "18px" }}>EMITIR NFES EM MASSA</Text></ModalHeader>
                    <ModalCloseButton />
                    <ModalBody px={{ base: 3, md: 6 }}>
                        <Box mb={4}>
                            <SeletorEmissorNfe
                                valor={emissorNfe}
                                onChange={setEmissorNfe}
                                config={configEmissor}
                                isDisabled={isLoadingNfeMassa}
                                mostrarEnsaio
                                ensaio={ensaio}
                                onEnsaioChange={setEnsaio}
                            />
                        </Box>

                        <VStack spacing={2} align="stretch">
                            {vendasSelecionadasEmitirNfeMassa && vendasSelecionadasEmitirNfeMassa.map((venda) => {
                                const status = statusVendasNfeMassa[venda.id] || 'NÃO PROCESSADO';
                                const emissorVenda = emissorDaVenda(venda.conta, escolhaEfetiva, configEmissor).tipo;
                                const podeCorrigir = status === 'ERRO' && emissorVenda === EMISSOR_INTERNO;
                                const ensaioVenda = resultadosEnsaio[venda.id];
                                const corBorda = status === 'ERRO' ? 'red.300' : (status === 'CONCLUÍDO' ? 'green.300' : (status === 'ENSAIO' ? 'purple.300' : 'gray.200'));

                                return (
                                    <Box key={venda.id} borderWidth="1px" borderColor={corBorda} rounded="md" p={2} bg="white">
                                        <Flex direction={{ base: "column", md: "row" }} gap={2} align={{ base: "stretch", md: "center" }}>
                                            <HStack flex="1" minW={0} spacing={2} align="flex-start">
                                                <Box boxSize="36px" flexShrink={0}>
                                                    {venda.produtos?.[0] && (
                                                        <ProdutoImagem produto={venda.produtos[0]} origem={venda.origem} width="36px" height="36px" />
                                                    )}
                                                </Box>
                                                <VStack align="flex-start" spacing={0} minW={0} flex="1">
                                                    <HStack spacing={1} flexWrap="wrap">
                                                        <Text fontSize="xs" fontWeight="bold">#{venda.id_taga || venda.id}</Text>
                                                        <Badge fontSize="9px" colorScheme={Number(venda.conta) === 1 ? "yellow" : (Number(venda.conta) === 3 ? "green" : "blue")}>Conta {venda.conta}</Badge>
                                                        {venda.pack_id && <Text fontSize="10px" color="purple.500" fontWeight="semibold">Pack {venda.pack_id}</Text>}
                                                    </HStack>
                                                    <Text fontSize="11px" color="gray.700" noOfLines={2} wordBreak="break-word">
                                                        {(venda.produtos || []).map((produto) => limitarCaracteres(produto.nome, 60)).join(' + ')}
                                                    </Text>
                                                    <Text fontSize="10px" color="gray.500" noOfLines={1}>{venda.comprador?.nickname}</Text>
                                                </VStack>
                                            </HStack>

                                            <HStack spacing={2} flexWrap="wrap" justify={{ base: "flex-start", md: "flex-end" }} flexShrink={0}>
                                                <BadgeEmissor conta={venda.conta} escolha={escolhaEfetiva} config={configEmissor} ensaio={ensaioAtivo} />

                                                {status === 'PROCESSANDO' && <Badge colorScheme="orange" display="flex" alignItems="center"><Spinner size="xs" mr={1} />Emitindo</Badge>}
                                                {status === 'CONCLUÍDO' && <Badge colorScheme="green">EMITIDA</Badge>}
                                                {status === 'ENSAIO' && <Badge colorScheme="purple">ENSAIO OK</Badge>}
                                                {status === 'ERRO' && (
                                                    <Tooltip label={mensagensErroNfeMassa[venda.id] || "Erro desconhecido"}>
                                                        <Badge colorScheme="red" display="flex" alignItems="center" cursor="help">ERRO<Box as={FaInfoCircle} ml={1} boxSize="10px" /></Badge>
                                                    </Tooltip>
                                                )}
                                                {status === 'NÃO PROCESSADO' && <Badge colorScheme="gray">NÃO PROCESSADO</Badge>}
                                                {customPayloads[venda.id] && status === 'ERRO' && (
                                                    <Badge colorScheme="purple" fontSize="8px">Editado</Badge>
                                                )}

                                                {podeCorrigir && (
                                                    <Tooltip label="Corrigir dados do cliente/endereço">
                                                        <IconButton
                                                            size="sm"
                                                            aria-label="Corrigir dados da nota"
                                                            icon={<FaEdit size={12} />}
                                                            colorScheme={customPayloads[venda.id] ? "purple" : "blue"}
                                                            onClick={() => handleOpenEditPayload(venda)}
                                                        />
                                                    </Tooltip>
                                                )}
                                                {customPayloads[venda.id] && status === 'ERRO' && (
                                                    <Tooltip label="Descartar correção">
                                                        <IconButton
                                                            size="sm"
                                                            aria-label="Descartar correção"
                                                            icon={<FaTrash size={12} />}
                                                            colorScheme="orange"
                                                            variant="outline"
                                                            onClick={() => handleDiscardPayload(venda.id)}
                                                        />
                                                    </Tooltip>
                                                )}
                                                <Tooltip label="Remover da lista">
                                                    <IconButton
                                                        size="sm"
                                                        aria-label="Remover da lista"
                                                        icon={<FaTrash size={12} />}
                                                        colorScheme="red"
                                                        variant="ghost"
                                                        isDisabled={isLoadingNfeMassa}
                                                        onClick={() => removerVendaEmitirNfeMasas(venda.id)}
                                                    />
                                                </Tooltip>
                                            </HStack>
                                        </Flex>

                                        {status === 'ERRO' && mensagensErroNfeMassa[venda.id] && (
                                            <Box mt={2} p={2} bg="red.50" rounded="md" borderWidth="1px" borderColor="red.100">
                                                <Text fontSize="xs" color="red.700" whiteSpace="pre-wrap" overflowWrap="anywhere">{mensagensErroNfeMassa[venda.id]}</Text>
                                            </Box>
                                        )}

                                        {status === 'ENSAIO' && ensaioVenda && (
                                            <Flex mt={2} p={2} bg="purple.50" rounded="md" borderWidth="1px" borderColor="purple.100" gap={2} direction={{ base: "column", sm: "row" }} align={{ base: "stretch", sm: "center" }} justify="space-between">
                                                <Box minW={0}>
                                                    <Text fontSize="xs" color="purple.800" fontWeight="semibold">
                                                        Homologação: NF nº {ensaioVenda.numero} série {ensaioVenda.serie} (sem valor fiscal)
                                                    </Text>
                                                    {ensaioVenda.chave && <Text fontSize="10px" color="purple.700" wordBreak="break-all">Chave {ensaioVenda.chave}</Text>}
                                                    {(ensaioVenda.avisos || []).map((aviso, i) => (
                                                        <Text key={i} fontSize="10px" color="orange.700">{aviso}</Text>
                                                    ))}
                                                </Box>
                                                <Button size="sm" leftIcon={<FaFilePdf />} colorScheme="purple" variant="outline" flexShrink={0}
                                                    isLoading={baixandoDanfe === venda.id} onClick={() => abrirDanfeEnsaio(venda.id)}>
                                                    DANFE do ensaio
                                                </Button>
                                            </Flex>
                                        )}
                                    </Box>
                                );
                            })}
                        </VStack>
                    </ModalBody>
                    <ModalFooter gap={2} flexWrap="wrap">
                        <Button
                            colorScheme={ensaioAtivo ? "purple" : "green"}
                            onClick={openModalConfirmNFMassa}
                            isLoading={isLoadingNfeMassa}
                            loadingText="Processando..."
                            isDisabled={isLoadingNfeMassa || !vendasSelecionadasEmitirNfeMassa?.length}
                            flex={{ base: 1, md: "initial" }}
                        >
                            {ensaioAtivo ? 'Emitir ensaio' : 'Confirmar'}
                        </Button>
                        <Button variant="ghost" onClick={handleCancelEmitirNfesMassaML} flex={{ base: 1, md: "initial" }}>Fechar</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>

        </div>
    );
};

export default ModalNfeVendas;
